import React from "react";
import * as LucideIcons from "lucide-react";

/**
 * Renders a horizontal row of coloured pills representing the driver's
 * badges (vignettes). Each badge is an object `{ id, label, color, icon }`.
 * The `color` field can be any CSS colour (hex, rgb, hsl). The `icon` is a
 * PascalCase lucide-react icon name; falls back to `Tag` if missing/unknown.
 *
 * Sizing is controlled by the `size` prop:
 *   - "sm" (default): compact pills for use inside driver cards
 *   - "md": slightly larger pills for admin lists
 */
export default function BadgePills({ badges, size = "sm", className = "" }) {
  if (!badges || badges.length === 0) return null;
  const sizeCls =
    size === "md"
      ? "text-[12px] px-2.5 py-1 gap-1.5"
      : "text-[11px] px-2 py-0.5 gap-1";
  const iconSize = size === "md" ? 12 : 10;
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="badge-pills">
      {badges.map((b) => {
        const IconComp = b.icon && LucideIcons[b.icon] ? LucideIcons[b.icon] : LucideIcons.Tag;
        const color = b.color || "#0EA5E9";
        return (
          <span
            key={b.id}
            className={`inline-flex items-center rounded-full font-medium leading-none ${sizeCls}`}
            style={{
              backgroundColor: `${color}18`, // ~10% opacity tint
              color: color,
              border: `1px solid ${color}55`,
            }}
            data-testid={`badge-pill-${b.id}`}
            title={b.label}
          >
            <IconComp size={iconSize} strokeWidth={2.2} />
            <span>{b.label}</span>
          </span>
        );
      })}
    </div>
  );
}
